import React from 'react';
import { MessageCircle } from 'lucide-react';
import { waGeneral } from '../config/pricing';

export default function Cancel() {
  return (
    <div className="page-pad">
      <div className="page-card">
        <div className="seal muted-seal">M</div>
        <h1>Checkout cancelled</h1>
        <p>Your payment was not taken. You can return to the collection or order through WhatsApp.</p>
        <div className="page-actions">
          <a href="/" className="btn btn-gold">Return to Collection</a>
          <a href={waGeneral()} className="btn btn-ghost" target="_blank" rel="noopener noreferrer">
            <MessageCircle size={14} /> Order on WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
